module.exports = __webpack_public_path__ + "img/susel-ana-maria-paredes-pique.4571e3ae.png";